import {
  Button,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLanguageName } from "../utils/generalFunctions";
import Loader from "../Components/Loader";
import { getProjectById } from "../features/projects/api";
import axios from "axios";
import {
  AUDIO_CHOPPING,
  CREATE_ALL_VOCALS_AUTOMATICALLY,
  DELETE_PROJECT,
  SYNC_LIPS,
  TRANSCRIBE,
  TRANSLATE,
  VOICE_TRAINING,
  VOICE_TRAINING_STATUS_CHECK,
  TRY_CLEAR_VOICES,
  GET_TASKS_STATUS,
  MERGING_FULL_API
} from "../ApiEndpoints";
import { ToastContainer, toast } from "react-toastify";
import DeleteConfirmationModal from "../Components/DeleteConfirmationModal";

import { useContext } from "react";
import { Store } from "../Store";
import { secondaryColor } from "../utils/constants.js";


const ActionsScreen = () => {
  const params = useParams();
  const { id: projectId } = params;
  // const { state } = useContext(Store);
  // const { accessToken } = state;
  const [dataLoader] = useState(false);
  const [projectFile, setProjectFile] = useState({});
  const [transcriptionStatus, setTranscriptionStatus] = useState("notStarted");
  const [checkAudioTrainingStatus, setcheckAudioTrainingStatus] =
    useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [deletedProjectName, setDeletedProjectName] = useState();
  const [deletedProjectId, setDeletedProjectId] = useState();

  const { state } = useContext(Store);
  const { userInfo } = state;
  const [translateMode, setTranslateMode] = useState("soft");
  const [createTakesMode, setCreateTakesMode] = useState("soft");
  const [translationStatus, setTranslationStatus] = useState("notStarted");
  const [voiceTrainingStatus, setVoiceTrainingStatus] = useState("notStarted");
  const [voiceGenerationStatus, setVoiceGenerationStatus] = useState("notStarted");
  const [remuxStatus, setRemuxStatus] = useState("notStarted");
  const [audioChoppingStatus, setAudioChoppingStatus] = useState("notStarted");

  const [transLang, setTransLang] = useState("");
  const [genLang, setGenLang] = useState("");
  const [syncLang, setSyncLang] = useState("");
  const [remuxLang, setRemuxLang] = useState("");

  // Normalize project creationDate into epoch milliseconds for reliable age checks.
  const getCreationDateMs = (creationDate) => {
    // Guard: return null when no creation date is available.
    if (!creationDate) {
      return null;
    }

    // Handle Firestore Timestamp-like objects with seconds/nanoseconds fields.
    if (typeof creationDate?.seconds === "number") {
      return creationDate.seconds * 1000 + Math.floor((creationDate.nanoseconds || 0) / 1000000);
    }

    // Handle native Date instances.
    if (creationDate instanceof Date) {
      return creationDate.getTime();
    }

    // Handle ISO date strings and numeric timestamps.
    if (typeof creationDate === "string" || typeof creationDate === "number") {
      // Parse the incoming value into a Date object.
      const parsedDate = new Date(creationDate);
      // Convert parsed date to milliseconds.
      const time = parsedDate.getTime();
      // Return null for invalid dates, otherwise return milliseconds.
      return Number.isNaN(time) ? null : time;
    }

    // Fallback: unsupported creationDate shape.
    return null;
  };

  // Compute the project creation time in milliseconds from project data.
  const projectCreationDateMs = getCreationDateMs(projectFile.creationDate);
  // Compute project age in milliseconds when creation time exists.
  const projectAgeMs = projectCreationDateMs ? Date.now() - projectCreationDateMs : null;
  // Mark as newly created only when transcription has not started and age is under 60 minutes.
  const isProjectNewlyCreated =
    transcriptionStatus === "notStarted" &&
    typeof projectAgeMs === "number" &&
    projectAgeMs >= 0 &&
    projectAgeMs < 60 * 60 * 1000;
  // Disable Transcribe only while in progress or during the newly-created cooldown.
  const isTranscribeDisabled =
    transcriptionStatus === "inProgress" || isProjectNewlyCreated;
  const fetchAllTaskStatuses = useCallback(async () => {
    try {
      const [transcribeRes, transRes, voiceTrainRes, voiceGenRes, chopRes] = await Promise.all([
        axios.post(GET_TASKS_STATUS, { projectId, taskName: "transcribe" }),
        axios.post(GET_TASKS_STATUS, { projectId, taskName: "translation" }),
        axios.post(GET_TASKS_STATUS, { projectId, taskName: "voiceTraining" }),
        axios.post(GET_TASKS_STATUS, { projectId, taskName: "voiceGeneration" }),
        axios.post(GET_TASKS_STATUS, { projectId, taskName: "audioChopping" }),
      ]);

      setTranscriptionStatus(transcribeRes.data.status || "notStarted");
      setTranslationStatus(transRes.data.status || "notStarted");
      setVoiceTrainingStatus(voiceTrainRes.data.status || "notStarted");
      setVoiceGenerationStatus(voiceGenRes.data.status || "notStarted");
      setAudioChoppingStatus(chopRes.data.status || "notStarted");
    } catch (err) {
      console.error("Error fetching task statuses:", err);
    }
  }, [projectId]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProjectById(projectId);
        setProjectFile(response.data);
      } catch (err) {
        console.log(err);
      }
    };
    const checkAudioTrainingStatus = async () => {
      try {
        const response = await axios.post(VOICE_TRAINING_STATUS_CHECK, {
          projectId: projectId,
        });

        setcheckAudioTrainingStatus(response.data.status);
      } catch (err) {
        console.log(err);
      }
    };

    const initialLoad = async () => {
      await fetchData();
      await checkAudioTrainingStatus();
      await fetchAllTaskStatuses(); // fetch once on mount
    };

    initialLoad();

    const interval = setInterval(() => {
      fetchAllTaskStatuses(); // refresh every 10s
    }, 10000);

    return () => clearInterval(interval);
  }, [projectId, fetchAllTaskStatuses]);

  async function transcribe() {
    try {
      const response = await axios.post(TRANSCRIBE, {
        url: projectFile.dialogueAudioUrl,
        projectId: projectId,
        language: projectFile.orginalLang,
      });
      console.log(response.data.taskId);
      toast.success("The movie is being transcribed");

      setTranscriptionStatus("inProgress");
    } catch (error) {
      toast.error("An Error has occured while transcribing");
    }
  }

  async function translate(language) {
    // helper that calls the backend
    const runTranslate = async () => {
      try {
        await axios.post(TRANSLATE, {
          projectId,
          newLanguage: language,
          mode: translateMode,
          userId: userInfo.id,
        });

        // const stored = localStorage.getItem("userInfo");
        // const { token } = JSON.parse(stored);

        // const res = await fetch(TRANSLATE, {
        //   method: "POST",
        //   headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`
        //   },
        //   body: JSON.stringify({
        //     projectId,
        //     newLanguage: language,
        //     mode: translateMode,
        //     userId: userInfo.id,
        //   })
        // });

        toast.success(`Movie has been translated to ${getLanguageName(language)}`);
      } catch {
        toast.error("An error occurred while translating");
      }
    };

    // HARD mode ➜ confirmation toast
    if (translateMode === "hard") {
      const toastId = toast.info(
        ({ closeToast }) => (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <span>
              Hard re-translate will <strong>overwrite existing translations</strong>.
              Continue?
            </span>

            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                size="small"
                onClick={async () => {
                  toast.dismiss(toastId);  // closes immediately
                  await runTranslate();    // then call the API
                }}
              >
                Confirm
              </Button>

              <Button
                variant="outlined"
                size="small"
                onClick={() => toast.dismiss(toastId)}  // just close
              >
                Cancel
              </Button>
            </div>
          </div>
        ),
        { autoClose: false, closeOnClick: false }
      );
    } else {
      // SOFT mode ➜ no confirmation
      await runTranslate();
    }
  }



  async function audioChopping() {
    try {
      // show immediate feedback
      toast.info("Audio chopping started...");

      setAudioChoppingStatus("inProgress");

      await axios.post(AUDIO_CHOPPING, { projectId });

      // when done
      toast.success("The Movie original audio has been chopped");
      setAudioChoppingStatus("completed");
    } catch (error) {
      toast.error("An error has occurred while chopping");
      setAudioChoppingStatus("failed");
    }
  }



  // async function audioTraining() {
  //   try {
  //     const response = await axios.post(VOICE_TRAINING, {
  //       projectId: projectId,
  //     });
  //     toast.success("The Movie voice id has been trained and added");
  //     setcheckAudioTrainingStatus(true);
  //   } catch (error) {
  //     toast.error("An Error has occured while training the voices");
  //   }
  // }

  async function audioTraining() {
    try {
      await axios.post(VOICE_TRAINING, {
        projectId: projectId,
        userId: userInfo.id  // Add the user ID here
      });
      toast.success("The Movie voice id has been trained and added");
      setcheckAudioTrainingStatus(true);
    } catch (error) {
      toast.error("An Error has occured while training the voices");
    }
  }

  async function releaseVoices() {
    try {
      await axios.post(TRY_CLEAR_VOICES, {
        projectId: projectId
        // dryRun: true
      });
      toast.success("The voices have been released successfully");
      setcheckAudioTrainingStatus(true);
    } catch (error) {
      toast.error("An Error has occured while releasing the voices");
    }
  }

  // Adopt the "takes" naming convention for this workflow going forward.
  async function createTakes(language) {
    // helper that actually calls the backend
    const runGenerate = async () => {
      try {
        await axios.post(CREATE_ALL_VOCALS_AUTOMATICALLY, {
          projectId,
          language,
          projectName: projectFile.name,
          // TODO: Remove dependency on creationDate for takes requests.
          creationDate: projectFile.creationDate,
          soft: createTakesMode === "soft",
        });
        toast.success(
          `Takes have been requested for ${getLanguageName(language)}`
        );
      } catch (error) {
        toast.error("An error has occurred while creating translated takes");
      }
    };

    // HARD mode ➜ confirmation toast
    if (createTakesMode === "hard") {
      const toastId = toast.info(
        ({ closeToast }) => (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <span>
              Hard re-populate will overwrite existing audio. Continue?
            </span>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                size="small"
                onClick={async () => {
                  toast.dismiss(toastId);
                  await runGenerate();
                }}
              >
                Confirm
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => toast.dismiss(toastId)}
              >
                Cancel
              </Button>
            </div>
          </div>
        ),
        { autoClose: false, closeOnClick: false }
      );
    } else {
      // SOFT mode – run immediately
      await runGenerate();
    }
  }


  async function syncLips(language) {
    try {
      await axios.post(SYNC_LIPS, {
        projectId: projectId,
        language: language,
        projectName: projectFile.name,
        videoUrl: projectFile.videoUrl,
      });

      toast.success(
        "Sync lips has been requested for all scenes for " +
        getLanguageName(language)
      );
    } catch (error) {
      toast.error("An Error has occured while syncing the lips");
    }
  }

  const toggleDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(!showDeleteConfirmModal);
  };

  const handleDeleteProjectAPI = async (id) => {
    try {
      const response = await axios.post(DELETE_PROJECT, {
        id: id,
      });
      console.log(response.data.msg);
      toast.success("Project has been deleted");
    } catch (error) {
      console.log(error);
      toast.error("An Error has occured while deleting the project");
    }
  };

  const makeVersionStamp = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
  };

  async function reRemux(language) {
    try {
      await axios.post(MERGING_FULL_API, {
        projectId,
        projectName: projectFile.name,
        langCode: language,
        version: makeVersionStamp(),           // auto version name = datetime
        submitterName: userInfo?.name,
        // keep the recipients minimal; add more if you want same list as QA page
        emails: [userInfo?.email].filter(Boolean),
      });
      toast.success(`Re-remux requested for ${getLanguageName(language)}`);
      setRemuxStatus("inProgress");
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while re-remuxing");
    }
  }

  const LangSelect = ({ value, onChange, languages, placeholder = "Choose language" }) => (
    <Select
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      displayEmpty
    >
      <MenuItem value="" disabled>{placeholder}</MenuItem>
      {languages?.map((language, index) => (
        <MenuItem key={index} value={language}>
          {getLanguageName(language)}
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <Grid item container justifyContent="center" marginBottom={24.7}>
      <Loader Load={dataLoader} />
      <ToastContainer position="top-center" />
      {/* {console.log(projectFile)} */}

      <Grid item container xs={7} marginTop={7} direction="column">
        <Grid item sx={{ fontSize: "var(--font-size-header)", fontWeight: "600" }}>
          Actions
        </Grid>
        <Grid item>
          <Table sx={{ minWidth: 650, bgcolor: "white" }}>
            <TableHead
              sx={{
                backgroundColor: secondaryColor,
                "& .MuiTableCell-root": { color: "var(--color-table-header-text)" },
              }}
            >
              <TableRow>
                <TableCell>Names</TableCell>
                <TableCell>Actions</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Transcription</TableCell>
                <TableCell>
                  <Button
                    onClick={() => transcribe()}
                    disabled={isTranscribeDisabled}
                  >
                    Transcribe
                  </Button>
                </TableCell>
                <TableCell>
                  {transcriptionStatus === "completed"
                    ? "Transcribed"
                    : transcriptionStatus === "inProgress"
                      ? "Transcribing..."
                      : transcriptionStatus === "failed"
                        ? "Failed"
                        : `Not transcribed yet${isProjectNewlyCreated ? " (Project Newly Created)" : ""}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Translation</TableCell>
                <TableCell>
                  <Grid container alignItems="center" columnGap={3} justifyContent="center">
                    <LangSelect
                      value={transLang}
                      onChange={setTransLang}
                      languages={projectFile.finalLang}
                      placeholder="Choose language"
                    />


                    <RadioGroup
                      value={translateMode}
                      onChange={(e) => setTranslateMode(e.target.value)}
                      sx={{ '& .MuiSvgIcon-root': { fontSize: "var(--font-size-normal)" } }}
                    >
                      <FormControlLabel
                        value="soft"
                        control={<Radio size="small" />}
                        label="Soft re-translate"
                        componentsProps={{ typography: { variant: 'body2' } }}
                      />
                      <FormControlLabel
                        value="hard"
                        control={<Radio size="small" />}
                        label="Hard re-translate"
                        componentsProps={{ typography: { variant: 'body2' } }}
                      />
                    </RadioGroup>

                    <Button
                      onClick={() => translate(transLang)}
                      disabled={!transLang}
                    >
                      Translate
                    </Button>

                  </Grid>
                </TableCell>
                <TableCell>
                  {translationStatus === "completed"
                    ? "Translated"
                    : translationStatus === "inProgress"
                      ? "Translating..."
                      : "Not translated yet"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Audio Chopping</TableCell>
                <TableCell>
                  <Button
                    onClick={() => audioChopping()}
                    // Disable if already running or completed
                    disabled={
                      audioChoppingStatus === "inProgress" ||
                      audioChoppingStatus === "completed"
                    }
                  >
                    Chop
                  </Button>
                </TableCell>
                <TableCell>
                  {audioChoppingStatus === "completed"
                    ? "Chopped"
                    : audioChoppingStatus === "inProgress"
                      ? "Chopping..."
                      : audioChoppingStatus === "failed"
                        ? "Failed"
                        : "Not chopped yet"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Voice Traning</TableCell>
                <TableCell>
                  <Button
                    onClick={() => audioTraining()}
                    disabled={checkAudioTrainingStatus}
                  >
                    Train
                  </Button>

                  <Button
                    onClick={() => releaseVoices()}
                  >
                    Release
                  </Button>

                </TableCell>
                <TableCell>
                  {voiceTrainingStatus === "completed"
                    ? "Trained"
                    : voiceTrainingStatus === "inProgress"
                      ? "Training..."
                      : "Not trained yet"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Create Takes</TableCell>
                <TableCell>
                  <Grid
                    container
                    alignItems="center"   // centers vertically
                    columnGap={2}
                    justifyContent="center" // centers horizontally in the cell
                  >
                    <LangSelect
                      value={genLang}
                      onChange={setGenLang}
                      languages={projectFile.finalLang}
                      placeholder="Choose language"
                    />

                    <RadioGroup
                      value={createTakesMode}
                      onChange={(e) => setCreateTakesMode(e.target.value)}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: "var(--font-size-normal)" } }}
                    >
                      <FormControlLabel value="soft" control={<Radio size="small" />} label="Soft re-populate" />
                      <FormControlLabel value="hard" control={<Radio size="small" />} label="Hard re-populate" />
                    </RadioGroup>
                    <Button
                      onClick={() => createTakes(genLang)}
                      disabled={!genLang}
                    >
                      Create Takes
                    </Button>
                  </Grid>
                </TableCell>
                <TableCell>
                  {voiceGenerationStatus === "completed"
                    ? "Generated"
                    : voiceGenerationStatus === "inProgress"
                      ? "Generating..."
                      : "Not generated yet"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Sync lips</TableCell>
                <TableCell>
                  <Grid container alignItems="center" columnGap={2} justifyContent="center">
                    <LangSelect
                      value={syncLang}
                      onChange={setSyncLang}
                      languages={projectFile.finalLang}
                      placeholder="Choose language"
                    />
                    <Button
                      onClick={() => syncLips(syncLang)}
                      disabled={!syncLang}
                    >
                      Sync
                    </Button>
                  </Grid>
                </TableCell>
                <TableCell>-</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>A/V Remux &amp; QA Review</TableCell>
                <TableCell>
                  <Grid container alignItems="center" columnGap={2} justifyContent="center">
                    <LangSelect
                      value={remuxLang}
                      onChange={setRemuxLang}
                      languages={projectFile.finalLang}
                      placeholder="Choose language"
                    />
                    <Button
                      onClick={() => reRemux(remuxLang)}
                      disabled={!remuxLang}
                    >
                      Re-remux
                    </Button>
                  </Grid>
                </TableCell>
                <TableCell>
                  {remuxStatus === "completed"
                    ? "Remuxed"
                    : remuxStatus === "inProgress"
                      ? "Re-remuxing..."
                      : "Not remuxed yet"}
                </TableCell>
              </TableRow>

            </TableBody>
          </Table>
        </Grid>
        <Grid item container marginTop={12} direction="column">
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={() => {
              toggleDeleteConfirmModal();
              setDeletedProjectName(projectFile.name);
              setDeletedProjectId(projectId);
              // handleDeleteProjectAPI(project.id);
            }}
          >
            Delete
          </Button>
          {showDeleteConfirmModal && (
            <DeleteConfirmationModal
              projectName={deletedProjectName}
              projectId={deletedProjectId}
              onClose={toggleDeleteConfirmModal}
              handleDeleteProjectAPI={handleDeleteProjectAPI}
            // handleRemoveProject={handleRemoveProject}
            />
          )}
        </Grid>
      </Grid >
    </Grid >
  );
};

export default ActionsScreen;
